import parse from 'html-react-parser';
import { EMPTY_STRING } from 'modules/core/constants';

export const parseContent = (content: string[]): ReturnType<typeof parse> => parse(content.join(EMPTY_STRING));
